import axios from 'axios'
import * as config from 'config'

/**
 * Validates the user's account by email confirmation
 * @param {string} userId The user identifier
 * @param {string} code The email confirmation token (code)
 */
const validateAccount = (userId, code) =>
	axios.post(`${config.apiUrl}identidade/confirmar-email`, { userId, code })

export { validateAccount }
